import { useQuery } from "@tanstack/react-query";
import type { EnabledOpportunityTypes, OpportunityGenerationType } from "@nexus/contracts";

import { tenantSettingsQueryOptions } from "@/lib/queries/tenant-settings.queries";

/** Loaded response with no field means every type stays creatable, matching the API default. */
export function isOpportunityTypeGenerationEnabled(
  types: EnabledOpportunityTypes | undefined,
  settingsLoaded: boolean,
  type: OpportunityGenerationType,
): boolean {
  if (!settingsLoaded) return false;
  if (types === undefined) return true;
  return types[type] !== false;
}

/** Missing tenant id — nothing to gate. */
export function useOpportunityGenerationEnabled(tenantId: string | null | undefined) {
  const { data, isPending } = useQuery(tenantSettingsQueryOptions(tenantId));
  const types = data?.enabledOpportunityTypes;
  const settingsLoaded = !tenantId || !isPending;

  return {
    isPersonaEnabled: isOpportunityTypeGenerationEnabled(types, settingsLoaded, "PERSONA"),
    isCompetitorEnabled: isOpportunityTypeGenerationEnabled(types, settingsLoaded, "COMPETITOR"),
    isCustomEnabled: isOpportunityTypeGenerationEnabled(types, settingsLoaded, "USER_GENERATED"),
    isPostFlightEnabled: isOpportunityTypeGenerationEnabled(types, settingsLoaded, "POST_FLIGHT"),
    /** False while `/tenant-settings` is in flight — avoids flashing every drive mode as available. */
    isOpportunityTypesReady: settingsLoaded,
  };
}
